export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/LinesGreen.323a7aaf.svg","height":12,"width":17,"blurWidth":0,"blurHeight":0};